var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('VTopToolbar',{attrs:{"title":"New task"},scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('app-menu')]},proxy:true}])}),_c('h1',{staticClass:"headline"},[_vm._v("New")]),_vm._v(" In progress! ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }